// Module
var code = " <div class=\"page-width\"> <h2>Setup your Pro Account</h2> <div class=\"row\"> <div class=\"col-12\"> <h3>Select your Service Areas</h3> </div> </div> <div class=\"row\"> <div class=\"col-12\"> <hr> </div> </div> <div class=\"row\"> <div class=\"col-12\"> <h3>Upgrade Your Plan Here</h3> </div> </div> </div> ";
// Exports
module.exports = code;